export default __webpack_public_path__ + "static/media/logo.85768f3c.png";